import { Dialog, DialogTrigger } from '@/components/atoms/Dialog';
import { Checkbox } from '@/components/atoms/PcCheckbox';
import { SIGNUP_TERMS } from '@/constants/signup-terms';
import { TermsDialogContent } from './terms-dialog-content';

interface Props {
  checkedItems: boolean[];
  handleAllCheck: () => void;
  handleSingleCheck: (index: number) => void;
}

export const SignupTerms = ({ checkedItems, handleAllCheck, handleSingleCheck }: Props) => {
  const allChecked = checkedItems.every(Boolean);

  return (
    <div className="w-full space-y-3">
      <div className="flex w-full items-center gap-2 text-left">
        <Checkbox checked={allChecked} onCheckedChange={handleAllCheck} />
        <span className="font-semibold text-gr-800 max-md:Body4S14">서비스 이용약관 전체 동의</span>
      </div>
      {SIGNUP_TERMS.map((terms, i) => (
        <div key={terms.label} className="flex items-center  gap-2">
          <Checkbox checked={checkedItems[i]} onCheckedChange={() => handleSingleCheck(i)} />{' '}
          <div className="flex items-center gap-1">
            <span className="text-gr-700 Caption1M12">[{terms.isOptional ? '선택' : '필수'}]</span>
            <span className="text-gr-700 Body5M14">{terms.label}</span>
          </div>
          <Dialog>
            <DialogTrigger className="text-sm text-gr-600 underline underline-offset-2">
              전문보기
            </DialogTrigger>
            <TermsDialogContent content={terms.termsContent} />
          </Dialog>
        </div>
      ))}
    </div>
  );
};
